import React, { useState, useEffect } from "react";
import BackgroundImage from "../../assets/images/img/SIGNUP-BG.png";
import LoginImg from "../../assets/images/img/login.png";
import Button from "../Common/Button";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useNetworkServices from "../../Networking/baseAPIManager";
import { HeaderLogo } from "./HeaderLogo";
import { Toastify } from "../Common/Toastify";

const NewPassword = () => {
  const { ResetPassword } = useNetworkServices();
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the otpToken from the location state
  const otpToken = location.state?.otpToken;

  // State to manage form inputs and error
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
    token: "",
  });

  console.log(otpToken, "otpToken");
  const [error, setError] = useState("");
  const [disable, setDisable] = useState("");
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (disable) return;

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match. Please make sure they are the same.");
      return;
    }
    setDisable(true);
    try {
      const response = await ResetPassword({
        newPassword: formData.password,
        // confirmPassword: formData.confirmPassword,
        token: formData.token,
      });
      console.log(response, response.data, "ResponseData");

      setType("success");
      setMessage( error?.response?.data?.message || "Oops! Something went wrong. Please try again.")
      setShow(true)
      navigate("/signin");
    } catch (error) {
      setType("error");
      setMessage( error?.response?.data?.message ||  "Oops! Something went wrong. Please try again.")
      setShow(true);
      console.error("Reset password error:", error?.response?.data?.message);
    } finally {
      setDisable(false);
    }
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      token: otpToken,
    }));
  }, [otpToken]);

  return (
    <>
      <div
        className="flex items-center justify-center min-h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <Toastify type={type} message={message} show={show} setShow={setShow} />
        <Link to="/">
          <HeaderLogo />
        </Link>
        <div className="container p-8 mt-28 lg:m-0 md:m-0">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-6 lg:col-span-6 flex items-center justify-center">
              <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0 dark:bg-white dark:border-gray-700">
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                  <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-gray-800">
                    New Password
                  </h1>
                  <p className="text-gray-400 text-sm">
                    Set a new password to keep your account safe.
                  </p>
                  {error && <p className="text-red-500">{error}</p>}
                  <form
                    className="mt-4 space-y-4 lg:mt-5 md:space-y-5"
                    onSubmit={handleSubmit}
                  >
                    <div>
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800"
                      >
                        Enter New Password
                      </label>
                      <input
                        type="password"
                        id="password"
                        value={formData.password}
                        onChange={(e) =>
                          setFormData({ ...formData, password: e.target.value })
                        }
                        className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="confirmPassword"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800"
                      >
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        id="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            confirmPassword: e.target.value,
                          })
                        }
                        className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                        required
                      />
                    </div>
                    <Button
                      type="submit"
                      disabled={disable}
                      className={`bg-[#E73921] w-full text-white font-bold py-2 px-4 rounded hover:bg-[#e56554fc] focus:ring-2 focus:ring-red-300 transition duration-300 
                              ${
                                disable ? "opacity-50 cursor-not-allowed" : ""
                              } `}
                      text={disable ? "Processing..." : "Submit"}
                    />
                  </form>
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-6 flex items-center justify-center">
              <img src={LoginImg} alt="Login" className="max-w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
